import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {distinctUntilChanged, skip, takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";

import {CommonPricingQueryModel} from "../../models/bundle.model";

@Component({
    selector: 'leap-bundle-license-form',
    templateUrl: './bundle-license-form.component.html',
    styleUrls: ['./bundle-license-form.component.less']
})
export class BundleLicenseFormComponent implements OnInit {
    @Input() bundleLicenses: CommonPricingQueryModel[];

    form: FormGroup;
    licenseTypes: string[];
    durationTypes: { duration: number, durationType: string }[];

    ngUnsubscribe = new Subject();

    constructor(private fb: FormBuilder) {
    }

    ngOnInit() {
        this.form = this.fb.group({
            sku: [],
            licenseTypeValue: [],
            currency: [],
            price: [],
            duration: [],
            durationType: [],
            combinedDuration: [],
        });

        this.licenseTypes = [...new Set(this.bundleLicenses.map(license => license.licenseTypeValue))];

        this.form.get('licenseTypeValue').valueChanges
            .pipe(
                takeUntil(this.ngUnsubscribe),
                distinctUntilChanged(),
            )
            .subscribe(licenseType => {
                    this.setDurations(licenseType);
                    this.setFormValues(this.bundleLicenses.find(license => license.licenseTypeValue === licenseType));
                }
            );

        this.form.get('combinedDuration').valueChanges
            .pipe(
                takeUntil(this.ngUnsubscribe),
                distinctUntilChanged(),
                skip(1)
            )
            .subscribe(licenseCombinedDuration => {
                if (!licenseCombinedDuration) {
                    return null;
                }
                    const license = this.bundleLicenses
                        .find(bundleLicense =>
                            bundleLicense.duration === licenseCombinedDuration.duration
                            && bundleLicense.durationType === licenseCombinedDuration.durationType
                        );
                    this.form.patchValue({
                        sku: license.sku,
                        duration: license.duration,
                        durationType: license.durationType,
                    })
                }
            );
    }

    private setFormValues(license: CommonPricingQueryModel): void {
        this.form.patchValue({
            sku: license.sku,
            licenseTypeValue: license.licenseTypeValue,
            currency: license.currency,
            price: license.price,
            duration: license.duration,
            durationType: license.durationType,
            combinedDuration: this.durationTypes && this.durationTypes[0]
        });
    }

    private setDurations(licenseType: string): void {
        this.durationTypes = this.bundleLicenses
            .filter(license => license.licenseTypeValue === licenseType)
            .map(license => ({duration: license.duration, durationType: license.durationType}))
            .filter(durations => durations.duration || durations.durationType);

    }
}
